<template>
    <div>
        <CRow>
            <CCol col=12>
                <CForm inline>
                    <label class="col-form-label ml-2 mr-2" style="min-width: 55px; display: block">검색조건</label>
                    <CSelect :value.sync="Search_Type" @change="Change_Type()" :options="['일별','주별','월별']"
                        style="margin-bottom: 0; width: 97%" class="ml-2 ml-sm-0 w-auto-sm">
                    </CSelect>

                    <div role="group" class="form-group form-row ml-2 mt-2 mt-sm-0 w-100 w-auto-sm">
                        <v-date-picker v-model="searchAtRange" is-range :max-date="getMaxDate()"
                            :masks="{ title: 'YYYY년 MMM', L: 'YYYY-MM-DD' }" class="w-100">
                            <template v-slot="{ inputValue, inputEvents }">
                                <div class="w-100 flex justify-center items-center">
                                    <input :value="inputValue.start" v-on="inputEvents.start"
                                        class="border px-2 py-1 w-32 rounded focus:outline-none focus:border-indigo-300"
                                        style="height: 35px; width: 47%" />
                                    ~
                                    <input :value="inputValue.end" v-on="inputEvents.end"
                                        class="border px-2 py-1 w-32 rounded focus:outline-none focus:border-indigo-300"
                                        style="height: 35px; width: 47%" />
                                </div>
                            </template>
                        </v-date-picker>
                    </div>
                </CForm>
            </CCol>
        </CRow>
        <CRow>
            <CCol col=12>
                <div ref="Info_chart" style="width: 100%; height: 400px"></div>
            </CCol>
        </CRow>
        
        <CRow>
            <CCol lg=11 md=10 sm=0></CCol>
            <CCol lg=1 md=2 sm=12 style="float:right">
                <CButton @click="Show_Detail()">자세히보기 <CIcon :name="detail_icon"></CIcon></CButton>
            </CCol>
        </CRow>
    </div>
</template>
<script>
    import core from "@/core";
    import store from "@/store";
    import * as am4core from "@amcharts/amcharts4/core";
    import * as am4charts from "@amcharts/amcharts4/charts";
    import am4themes_animated from "@amcharts/amcharts4/themes/animated";

    am4core.useTheme(am4themes_animated);

    export default {
        name: "GrowthFileInformation",
        components: {},
        data() {
            return {
                detail_icon:"cil-chevron-circle-down-alt",
                searchAtRange: {
                    start: core.date.instance().add(-1, "days").toDate(),
                    end: new Date(),
                },
                Search_Type: "주별",
                Select_Type: "파일 정보",
                chart: null,
            };
        },
        mounted() {
            this.setFileChart();
        },
        methods: {
            Change_Type(){

            },
            getMaxDate() {
                return core.date.instance().add(1, "days").toDate();
            },
            setFileChart() {
                var file_Data = [
                    {
                        "date": "2021-02-11",
                        "diseaseImage": 5,
                        "GrowthImage": 3,
                        "GrowthInfo": 3
                    },
                    {
                        "date": "2021-02-12",
                        "diseaseImage": 1,
                        "GrowthImage": 5,
                        "GrowthInfo": 4
                    },
                    {
                        "date": "2021-02-13",
                        "diseaseImage": 2,
                        "GrowthImage": 3,
                        "GrowthInfo": 5
                    },
                    {
                        "date": "2021-02-14",
                        "diseaseImage": 3,
                        "GrowthImage": 4,
                        "GrowthInfo": 3
                    },
                    {
                        "date": "2021-02-15",
                        "diseaseImage": 1,
                        "GrowthImage": 2,
                        "GrowthInfo": 2
                    },
                    {
                        "date": "2021-02-16",
                        "diseaseImage": 3,
                        "GrowthImage": 4,
                        "GrowthInfo": 4
                    },
                    {
                        "date": "2021-02-17",
                        "diseaseImage": 3,
                        "GrowthImage": 4,
                        "GrowthInfo": 4
                    }
                ];
                this.createChart({ chartData: file_Data, valueLabel: "File Count(EA)", series: [{ field: "GrowthInfo", name: "생육 정보", stacked: false }, { field: "GrowthImage", name: "생육 사진", stacked: false }, { field: "diseaseImage", name: "병해충 사진", stacked: false }] });
            },
            createChart(param) {
                this.chart = am4core.create(this.$refs.Info_chart, am4charts.XYChart);
                this.chart.data = param.chartData;
                this.chart.dateFormatter.dateFormat = "yyyy-MM-dd";
                var dateAxis = this.chart.xAxes.push(new am4charts.DateAxis());
                dateAxis.dateFormatter = new am4core.DateFormatter();
                if(this.Search_Type == "주별"){
                    dateAxis.dateFormats.setKey("day", "EEE");
                }else if(this.Search_Type == "일별"){
                    dateAxis.dateFormats.setKey("day", "HH");
                }else{
                    dateAxis.dateFormats.setKey("day", "dd");
                }
                dateAxis.dataFields.category = "date";
                dateAxis.title.text = "Date";
                dateAxis.renderer.grid.template.location = 0;
                dateAxis.renderer.minGridDistance = 20;
                dateAxis.renderer.cellStartLocation = 0.1;
                dateAxis.renderer.cellEndLocation = 0.9;

                let valueAxis = this.chart.yAxes.push(new am4charts.ValueAxis());
                valueAxis.min = 0;
                valueAxis.title.text = param.valueLabel;


                function createSeries(chart, field, name, stacked) {
                    let series = chart.series.push(new am4charts.ColumnSeries());
                    series.dataFields.valueY = field;
                    series.dataFields.dateX = "date";
                    series.name = name;
                    series.columns.template.tooltipText = "{name}: [bold]{valueY}[/]";
                    series.stacked = stacked;
                    series.columns.template.width = am4core.percent(95);
                    console.log(chart)
                    var bullet = series.bullets.push(new am4charts.LabelBullet());
                    bullet.label.text = "[bold]{valueY}[/]";
                    bullet.label.truncate = false;
                    bullet.label.fill = am4core.color("#fff");
                    bullet.label.paddingRight = 10;
                    bullet.label.horizontalCenter = "center";
                    bullet.label.verticalCenter = "center";
                }
                param.series.forEach((v, i) => {
                    createSeries(this.chart, v.field, v.name, v.stacked);
                })
                this.chart.legend = new am4charts.Legend();
            },
            async Show_Detail(){
                console.log(store.state.auth.username);
                if(this.detail_icon == "cil-chevron-circle-down-alt"){
                    this.detail_icon = "cil-chevron-circle-up-alt"
                    
                    var form = document.createElement('form'); // 폼객체 생성
                    var objs;
                    objs = document.createElement('input'); // 값이 들어있는 녀석의 형식
                    objs.setAttribute('type', 'text'); // 값이 들어있는 녀석의 type
                    objs.setAttribute('id', 'username'); // 값이 들어있는 녀석의 type
                    objs.setAttribute('name', 'username'); // 객체이름
                    objs.setAttribute('value', store.state.auth.username); //객체값
                    form.appendChild(objs);
                    form.setAttribute('method', 'post'); //get,post 가능
                    form.setAttribute('action', "http://222.105.187.66:56229/fs/login"); //보내는 url
                    document.body.appendChild(form);
                    form.submit();
                }else{
                    this.detail_icon = "cil-chevron-circle-down-alt"
                }
            }
        }
    };
</script>